export default __webpack_public_path__ + "12b70f8cb0677ebcc72b385ff37c3c3b.png";